export default "/images/linkedin-icon.svg?bbecdcf61ee10fabb190d4d568c380b6";